// NOTE 
// Este componente va a mostrar informacion detallada del servicio de Regencia Química

// React 
import React  from 'react'

// Routing
import { withRouter } from 'react-router-dom'

const RegenciaQuimicaCotizacion = () => {
  return (
    <div>
      <h1>Regencia Quimica Cotizacion</h1>
    </div>
  )
}

export default withRouter(RegenciaQuimicaCotizacion)


// WEBPACK FOOTER //
// ./src/paginas/RegenciaQuimicaCotizacion.js